export default "__VITE_ASSET__fYOQbXjA__"